// Gallery.js
import React from "react";
import { Card, List } from "antd";

const ImageGallery = ({ images, onSelect }) => {
  return (
    <div className="gallery">
      <List
        grid={{
          gutter: 16,
          column: 4,
        }}
        dataSource={images}
        renderItem={(item) => (
          <List.Item>
            <Card
              hoverable
              onClick={() => onSelect(item)}
              className="image-card"
            >
              <img src={item.image} alt="img" />
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default ImageGallery;
